// extracted by mini-css-extract-plugin
export default {"container":"ProductsContainer_container__I2Xkb"};